// export const EP = "https://cfgapp.figueras.com/api/";
// export const EP = "https://configurator.stg.figueras.com/api/";
export const EP = process.env.REACT_APP_EP;
